import { jsx } from 'react/jsx-runtime';

const Logo = (props) => {
    return (jsx("img", Object.assign({ alt: "Logo", src: "/static/client/logo.svg", onError: ev => {
            ev.currentTarget.src = '/static/logo.svg';
        } }, props)));
};

export { Logo };
